import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import React from "react";

import { CONFIRMATION_DIALOG } from "./AccountEditorConsts";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const ConfirmationDialog = ({
  open,
  isLoading,
  onDiscard,
  onClose,
  onSubmit,
  isSaveDisabled,
  accountName
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogContent>
      <Typography variant="body1" color="text.800">
        {CONFIRMATION_DIALOG.title.replace("$accountName", accountName)}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <HyroButton variant={BUTTON_VARIANTS.TEXT} color={BUTTON_COLORS.SECONDARY} onClick={onDiscard}>Discard</HyroButton>
      <HyroButton
        loading={isLoading}
        disabled={isSaveDisabled}
        variant={BUTTON_VARIANTS.CONTAINED}
        color={BUTTON_COLORS.PRIMARY}
        onClick={onSubmit}
        data-testid='save-changes'
      >
        {CONFIRMATION_DIALOG.buttonText}
      </HyroButton>
    </DialogActions>
  </Dialog >
);

export default ConfirmationDialog;
